import { useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { TableSortLabel, lighten, darken, alpha } from '@material-ui/core';
import clsx from 'clsx';

import ColumnCell from './ColumnCell';
import ColumnWidthAdjuster from './ColumnWidthAdjuster';
import { useSetTableSorters } from '../TableState';

const useStyles = makeStyles((theme) => ({
    root: {
        border: 'none',
        position: 'relative',
    },

    fullWidthButton: {
        width: '100%',
    },

    ellipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
    },

    adjustable: {
        '&:hover': {
            backgroundColor:
                theme.palette.type === 'light'
                    ? darken(alpha(theme.palette.background.paper, 1), 0.02)
                    : lighten(alpha(theme.palette.background.paper, 1), 0.06),

            '& $resizerHover': {
                display: 'initial',
            },
        },
    },

    resizerHover: {
        display: 'none',
    },
}));

export default function HeaderCell(props) {
    const { children, column, tooltip, lastColumn } = props;
    const { sortable, isSorted, sortProperty, sortDirection } = column;
    const setTableSorters = useSetTableSorters();
    const classes = useStyles();
    const isAdjustable = !lastColumn && column.resizable !== false;

    const onClick = useCallback(() => {
        const direction = sortDirection === 'desc' ? 'asc' : 'desc';

        setTableSorters([{ property: sortProperty, direction }]);
    }, [setTableSorters, sortDirection, sortProperty]);

    return (
        <ColumnCell
            variant="head"
            column={column}
            tooltip={tooltip}
            className={clsx(classes.root, column.headerClassName, isAdjustable && classes.adjustable)}
        >
            {sortable ? (
                <TableSortLabel
                    active={isSorted}
                    direction={sortDirection}
                    onClick={onClick}
                    className={classes.fullWidthButton}
                >
                    <div className={classes.ellipsis}>{children}</div>
                </TableSortLabel>
            ) : (
                <div>{children}</div>
            )}

            {isAdjustable && <ColumnWidthAdjuster className={classes.resizerHover} column={column} />}
        </ColumnCell>
    );
}
